import { Box, Flex, HStack } from "@chakra-ui/react";
import { Button, Descriptions, Space } from "antd";
import { StaffRoutes } from "appRoutePaths";
import { AccountType } from "models/accountSummary";
import { PackageAmount, StaffPackage } from "models/packages";
import { PackageQRCodeLink } from "pages/staff/NewPackage";
import { Link } from "react-router-dom";
import { isNewSilentUser, localizedDate } from "util/helpers";

const CreatedPackageDetail = (props: {
    prevPackage?: StaffPackage;
    package: StaffPackage;
    onAddNext: () => void;
}) => {
    const { package: pkg } = props;
    const isSilent = pkg.accountType === AccountType.Silent;

    return (
        <Flex flexDirection="column">
            <Flex py={3} justifyContent='space-between'>
                <div>
                    <PackageQRCodeLink id={pkg.id} />
                </div>
                <Space>
                    ID:
                    <Box fontWeight="semibold" pl={2}>
                        {pkg.friendlyId}
                    </Box>
                </Space>
            </Flex>
            <Descriptions layout="horizontal" column={1} bordered>
                <Descriptions.Item
                    label={isSilent ? "Breaker Name:" : "Sender Name:"}
                    style={{ fontSize: 18 }}
                >
                    {pkg.senderFirstName} {pkg.senderLastName}
                </Descriptions.Item>
                <Descriptions.Item
                    label="Customer(s):"
                    style={{ fontSize: 18 }}
                >
                    {pkg.owners.map(o => {
                        if (isNewSilentUser(o)) {
                            return <p>{o.userName}</p>
                        }
                        return <p>{`${o.firstName} ${o.lastName}`}</p>
                    })}
                </Descriptions.Item>
                <Descriptions.Item
                    label="Package Type:"
                    style={{ fontSize: 18 }}
                >
                    {pkg.packageTypeDisplayName}
                </Descriptions.Item>
                <Descriptions.Item label="Amount:" style={{ fontSize: 18 }}>
                    {PackageAmount[pkg.packageAmount]}
                </Descriptions.Item>
                <Descriptions.Item label="Last 4 Tracking #:" style={{ fontSize: 18 }}>
                    {pkg.trackingNumberSuffix ?? 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item
                    label="Date Received:"
                    style={{ fontSize: 18 }}
                >
                    {localizedDate(pkg.receivedDate)}
                </Descriptions.Item>
                <Descriptions.Item
                    label="Est. Upload Date:"
                    style={{ fontSize: 18 }}
                >
                    {localizedDate(pkg.estimatedUploadDate)}
                </Descriptions.Item>
            </Descriptions>
            <HStack pt={4} spacing={6} alignSelf="flex-end">
                {props.prevPackage && <PackageQRCodeLink id={props.prevPackage.id} text="Prev. QR Code" />}
                <Button size="large">
                    <Link to={StaffRoutes.packages.url}>Close</Link>
                </Button>
                <Button size="large" type="primary" onClick={props.onAddNext}>
                    Add Next
                </Button>
            </HStack>
        </Flex>
    );
};

export default CreatedPackageDetail;
